import React, { useState, useEffect, useRef } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ChevronUp } from 'feather-icons-react/build/IconComponents';
import { setToogleHeader } from '../../core/redux/action';
import { PlusCircle } from 'react-feather';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import Table from "../../core/pagination/datatable";
import AddPlan from '../../core/modals/usermanagement/addplan'
import { useToast } from '../../Toaster/ToastContext';
import Loader from '../loader/loader';
import { GetSubscriptionPlans, deletePlan } from '../../services/subscriptionService';

const Subscriptionplans = () => {

    const dispatch = useDispatch();
    const data = useSelector((state) => state.toggle_header);
    const [currentPlan, setCurrentPlan] = useState(null);
    const [plans, setPlans] = useState([]);
    const [filteredPlans, setFilteredPlans] = useState([]);
    const [loading, setLoading] = useState(false);
    const { showToast } = useToast();
    const hasFetched = useRef(false);
    const [activeTab, setActiveTab] = useState('all');

    const renderCollapseTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Collapse
        </Tooltip>
    )

    const fetchPlans = async () => {
        if (hasFetched.current) return;
        setLoading(true);
        try {
            const response = await GetSubscriptionPlans({
                pageIndex: 0,
                pageSize: 50,
                previousPageIndex: 0,
            });
            const data = await response.json();
            if (data.success) {
                const parsedPlans = data.data.map(plan => ({
                ...plan,
                custom_features: typeof plan.custom_features === 'string' ? JSON.parse(plan.custom_features)
                : Array.isArray(plan.custom_features) ? plan.custom_features
                : [],
                }));
                setPlans(parsedPlans);
                // setFilteredPlans(parsedPlans);
                setFilteredPlans(activeTab === 'all' ? parsedPlans : parsedPlans.filter(plan => {
                    switch (activeTab) {
                        case 'monthly': return plan.interval === 0;
                        case 'yearly': return plan.interval === 1;
                        case 'lifetime': return plan.interval === 2;
                        case '3months': return plan.interval === 3;
                        default: return true;
                    }
                }));
            } else {
                setPlans([]);
                setFilteredPlans([]);
            }
        } catch (error) {
            showToast(error.message || 'Failed to fetch categories', 'error', 'Categories');
        } finally {
            setLoading(false);
            hasFetched.current = true;
        }
    };

    useEffect(() => {
        fetchPlans();
    }, []);

    useEffect(() => {
        setFilteredPlans(plans.filter(plan => {
            switch (activeTab) {
                case 'monthly': return plan.interval === 0;
                case 'yearly': return plan.interval === 1;
                case 'lifetime': return plan.interval === 2;
                case '3months': return plan.interval === 3;
                default: return true;
            }
        }));
    }, [activeTab, plans]);

    const handleAddPlan = () => {
        setCurrentPlan(null);
    };

    const handleEditPlan = (plan) => {
        setCurrentPlan(plan);
    };

    const columns = [
        {
            title: "Plan Name",
            dataIndex: "name",
            render: (text) => <span className="text-wrap">{text}</span>,
            sorter: (a, b) => a.name.length - b.name.length,
            width: 200,
        },
       
        {
            title: "Color",
            dataIndex: "color",
            sorter: (a, b) => a.color.length - b.color.length,
            render: (color) => (
                <div
                    style={{
                        width: '20px',
                        height: '20px',
                        backgroundColor: color,
                        border: '1px solid #ccc',
                        display: 'inline-block',
                    }}
                />
            ),
            width: 100,
        },

        {
            title: "Duration",
            dataIndex: "interval",
            sorter: (a, b) => a.interval.length - b.interval.length,
            render: (interval) => {
            switch (interval) {
                case 0:
                    return 'Monthly';
                case 1:
                    return 'Yearly';
                case 2:
                    return 'Lifetime';
                default:
                    return interval;
            }
            },
            width: 100,
        },

        {
            title: "Description",
            dataIndex: "short_description",
            render: (text) => <span className="text-wrap">{text}</span>,
            sorter: (a, b) => a.short_description.length - b.short_description.length,
            width: 200
        },

        {
            title: "Free Plan",
            dataIndex: "free_plan",
            sorter: (a, b) => a.free_plan.length - b.free_plan.length,
            width: 100
        },

        {
            title: "Price",
            dataIndex: "price",
            render: (price) => <span className="text-wrap">{price}</span>,
            sorter: (a, b) => a.price.length - b.price.length,
            width: 200
        },

        {
    title: "Custom Features",
    dataIndex: "custom_features",
    sorter: (a, b) => a.custom_features.length - b.custom_features.length,
    render: (custom_features) => (
        <span className="text-wrap">
            {Array.isArray(custom_features)
                ? custom_features.length > 0
                    ? custom_features.map((feature) => feature.name).join(', ')
                    : ''
                : ''}
        </span>
    ),
    width: 250
},        {
            title: "No of Users",
            dataIndex: "no_of_users",
            render: (no_of_users) => <span className="text-wrap">{no_of_users}</span>,
            sorter: (a, b) => a.no_of_users.length - b.no_of_users.length,
            width: 200
        },

        {
            title: 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record) => (
                <td className="action-table-data">
                    <div className="edit-delete-action">
                        <Link className="me-2 p-2" to="#" data-bs-toggle="modal" data-bs-target="#add-plan"  onClick={() => handleEditPlan(record)}>
                            <i data-feather="edit" className="feather-edit"></i>
                        </Link>
                        <Link className="confirm-text p-2" to="#" onClick={() => showConfirmationAlert(record)} >
                            <i data-feather="trash-2" className="feather-trash-2"></i>
                        </Link>
                    </div>
                </td>
            ),
            width: 150
        },
    ];
    const MySwal = withReactContent(Swal);

    const showConfirmationAlert = async (record) => {
        try {
            const result = await MySwal.fire({
                title: 'Are you sure?',
                text: 'You won\'t be able to revert this!',
                showCancelButton: true,
                confirmButtonColor: '#00ff00',
                confirmButtonText: 'Yes, delete it!',
                cancelButtonColor: '#ff0000',
                cancelButtonText: 'Cancel',
            })
            if (result.isConfirmed) {
                try {
                    setLoading(true);
                    await deletePlan(record.id);
                    showToast('Plan deleted successfully', 'success', 'Subscription Plans');
                    hasFetched.current = false;
                    await fetchPlans();
                } catch (error) {
                    showToast(error.message || 'Failed to delete plan', 'error', 'Subscription Plans');
                } finally {
                    setLoading(false);
                }
            } else {
                MySwal.close();
            }
        }
        catch (error) {
            showToast('An error occurred', 'error', 'Subscription Plans');
        }
    };

    return (
        <div>
            <style>
                {`
                    .nav-tabs {
                        border-bottom: 1px solid #e5e7eb;
                        display: flex;
                        gap: 1.5rem;
                        padding-bottom: 0;
                    }
                    .nav-item {
                        margin-bottom: -2px !important;
                    }
                    .nav-link {
                        border: none !important;
                        border-bottom: 2px solid transparent;
                        background: none;
                        color: #6b7280;
                        font-weight: 500;
                        padding: 0.5rem 1rem;
                        transition: color 0.2s ease;
                    }
                    .nav-link:hover {
                        color: #374151;
                    }
                    .nav-link.active {
                        border-bottom: 5px solid #f59e0b !important;
                        color: #1f2937 !important;
                        font-weight: 600 !important;
                    }
                    
                `}
            </style>
            <Loader loading={loading} />
            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>Plan List</h4>
                                <h6>Manage Your plans</h6>
                            </div>
                        </div>
                        <ul className="table-top-head">
                            <li>
                                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                                    <Link
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        id="collapse-header"
                                        className={data ? "active" : ""}
                                        onClick={() => { dispatch(setToogleHeader(!data)) }}
                                    >
                                        <ChevronUp />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                        </ul>
                        <div className="page-btn">
                            <a to="#"
                                className="btn btn-added"
                                data-bs-toggle="modal"
                                data-bs-target="#add-plan"
                                onClick={handleAddPlan}
                            >
                                <PlusCircle className="me-2" />
                                Add New Plan
                            </a>
                        </div>
                    </div>
                    {/* /product list */}
                    <div className="card table-list-card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3" style={{padding: '1rem 1.25rem 0'}}>
                            <div className="tabs-menu">
                                <ul className="nav nav-tabs">
                                    <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeTab === 'all' ? 'active' : ''} px-4 py-2`}
                                            onClick={() => setActiveTab('all')}
                                        >
                                            All Plans
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeTab === 'monthly' ? 'active' : ''} px-4 py-2`}
                                            onClick={() => setActiveTab('monthly')}
                                        >
                                            Monthly Plans
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeTab === 'yearly' ? 'active' : ''} px-4 py-2`}
                                            onClick={() => setActiveTab('yearly')}
                                        >
                                            Yearly Plans
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeTab === 'lifetime' ? 'active' : ''} px-4 py-2`}
                                            onClick={() => setActiveTab('lifetime')}
                                        >
                                            Lifetime Plans
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeTab === '3months' ? 'active' : ''} px-4 py-2`}
                                            onClick={() => setActiveTab('3months')}
                                        >
                                            3-Months Plans
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            {/* <div className="search-set">
                                <div className="search-input">
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="form-control form-control-sm formsearch"
                                        onChange={handleSearch}
                                    />
                                    <Link to="#" className="btn btn-searchset">
                                        <i data-feather="search" className="feather-search" />
                                    </Link>
                                </div>
                            </div> */}
                        </div>
                        <div className="card-body pb-0">
                            <div className="table-responsive">
                                <Table
                                    columns={columns}
                                    dataSource={filteredPlans}
                                    rowKey={(record) => record.id}
                                    rowSelection={null}
                                />
                            </div>
                        </div>
                    </div>
                    {/* /product list */}
                </div>
            </div>

            <AddPlan 
                plan={currentPlan}
                onSave={() => {
                    hasFetched.current = false;
                    fetchPlans();
                }}
            />
        </div>
    )
}

export default Subscriptionplans
